import React from 'react'
import styled from 'styled-components'
import coin from '../../images/gamification/instruction-coin.png'
import sample from '../../images/gamification/instruction-sampleBtn.gif'
import hintL from '../../images/gamification/hint-textL.png'
import hint from '../../images/gamification/hint-text.png'
import { SIZES } from '../../styles/theme'

const Wrapper = styled.div`
  padding: 12px;
  color: #022136;
  font-size: 90%;
  h6 {
    color: #F85D49;
    font-weight: 600;
  }
  h6, p {
    width: 90%;
    margin: 10px auto;
  }
  p {
    display: flex;
    span {
      margin-left: 6px;
    }
  }
  
  #sample-btn {
    position: absolute;
    top: 7%;
    left: 50%;
  }
  #hint {
    position: absolute;
    top: 10%;
    left: 75%;
  }
  #mobile-hint {
    display: none;
  }
  ${SIZES.mobile} {
    h6 {
      text-align: center;
      padding-bottom: 6px;
      border-bottom: 2px solid #F85D49;
    }
    p {
      font-size: 80%;
    }
    #hint {
      display: none;
    }
    #mobile-hint {
      display: inline-block;
    }
    #sample-btn, #mobile-hint {
      margin-top: -20px;
      position: static;
    }
  }
`

function InstructionTab({ setTab }) {
  return (
    <Wrapper>
      <h6>How-To-Play Guide</h6>
      <p>1.<span>Choose a task to complete.</span></p>
      <p>2.<span>At the task page, click on indicated button.</span></p>
      <img id="sample-btn" src={sample} className="ml-5" width="20%" alt="coin sample" />
      <img id="hint" src={hintL} width="20%" alt="hint" />
      <img id="mobile-hint" src={hint} width="30%" alt="hint" />
      <p>3.<span>When the point token appears, click to collect.</span></p>
      <img src={coin} className="ml-5" width="30%" alt="coin sample" />
      <p>4.<span>Repeat the above with other tasks at each booth to collect more points.</span></p>
      <p>5.<span>Note: You can only collect the points once a day at each booth.</span></p>
      <p>6.<span>The game re-starts each day so everyone can play again.</span></p>
      <p>Note: Hunters can only win 1 prize.</p>
      <button onClick={()=>setTab("Mission Tasks")} className="start-button">START PLAYING</button>
    </Wrapper>
  )
}

export { InstructionTab }